import { render, staticRenderFns } from "./NumberBlocks.vue?vue&type=template&id=5cd49328"
import script from "./NumberBlocks.vue?vue&type=script&lang=js"
export * from "./NumberBlocks.vue?vue&type=script&lang=js"
import style0 from "./NumberBlocks.vue?vue&type=style&index=0&id=5cd49328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports